import contentDisposition from 'content-disposition';

const getFilenameFromResponse = (response) => {
    return contentDisposition.parse(response.headers.get('Content-Disposition'))
        .parameters.filename;
};

export default getFilenameFromResponse;
